import { api } from '../../config/api'

const basePath = 'dashboard/horas-extras'

/**
 * Get all
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const getAll = (options) => {
	const options_default = {}

	// Merge config
	options = Object.assign({}, options_default, options)

	let params = []
	let params_qs = ''
	if (options.hasOwnProperty("empresa_uuid")) {
		params.push(`empresa_uuid=${options.empresa_uuid}`);
	}

	if (options.hasOwnProperty("departamento_uuid")) {
		params.push(`departamento_uuid=${options.departamento_uuid}`);
	}

	if (options.hasOwnProperty("funcionario_uuid")) {
		params.push(`funcionario_uuid=${options.funcionario_uuid}`);
	}

	if (options.hasOwnProperty("inicio") && options.hasOwnProperty("fim")) {
		params.push(`inicio=${options.inicio}`);
		params.push(`fim=${options.fim}`);
	}

	if (options.hasOwnProperty("group_by")) {
		params.push(`group_by=${options.group_by}`);
	}

	if (params.length) {
		params_qs = `?${params.join('&')}`
	}

	return api.get(`${basePath}${params_qs}`)
}
